(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logo-marquee')) {
    class LogoMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.set = this.querySelector('[data-set]');
        if (!this.track || !this.set || !this.set.children.length) return;

        this.mode = this.dataset.mode;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.mode === 'static' || reduced) {
          this.classList.add('is-static');
          return;
        }

        this.build = this.build.bind(this);
        this.onResize = () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(this.build, 200);
        };
        this.lastWidth = 0;
        this.ro = new ResizeObserver(() => {
          if (this.offsetWidth !== this.lastWidth) this.onResize();
        });
        this.ro.observe(this);

        this.set.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
        });

        if (this.dataset.pauseHover === 'true') {
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
        }
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        this.build();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        this.stopSlide();
      }

      build() {
        this.stopSlide();
        this.lastWidth = this.offsetWidth;
        this.track.querySelectorAll('[data-clone]').forEach((n) => n.remove());
        this.track.style.transition = 'none';
        this.track.style.transform = '';

        const setWidth = this.set.getBoundingClientRect().width;
        const viewWidth = this.offsetWidth;
        if (!setWidth || !viewWidth) return;

        // Enough copies to always fill the screen, plus one for the loop
        const copies = Math.ceil(viewWidth / setWidth) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.set.cloneNode(true);
          clone.removeAttribute('data-set');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(clone);
        }

        if (this.mode === 'slide') {
          this.classList.remove('is-marquee');
          this.startSlide(setWidth);
        } else {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const speed = parseFloat(isMobile ? this.dataset.speedMobile : this.dataset.speed) || 50;
          this.style.setProperty('--lm-distance', setWidth + 'px');
          this.style.setProperty('--lm-duration', (setWidth / speed).toFixed(2) + 's');
          this.track.style.transition = '';
          this.classList.remove('is-marquee');
          void this.track.offsetWidth; // restart animation with new values
          this.classList.add('is-marquee');
        }
      }

      startSlide(setWidth) {
        const items = Array.from(this.set.children);
        const widths = items.map((el) => el.getBoundingClientRect().width);
        const count = items.length;
        const toLeft = this.dataset.direction !== 'right';
        const duration = parseInt(this.dataset.duration, 10) || 600;
        const delay = (parseFloat(this.dataset.delay) || 2.5) * 1000;

        let x = toLeft ? 0 : setWidth;
        let index = toLeft ? 0 : count;

        const apply = (animate) => {
          this.track.style.transition = animate ? `transform ${duration}ms ease` : 'none';
          this.track.style.transform = `translate3d(${-x}px, 0, 0)`;
        };
        apply(false);

        this.slideTimer = setInterval(() => {
          if (this.paused || document.hidden) return;

          if (toLeft) {
            x += widths[index];
            index++;
          } else {
            index--;
            x -= widths[index];
          }
          apply(true);

          const wrapped = toLeft ? index >= count : index <= 0;
          if (wrapped) {
            clearTimeout(this.snapTimer);
            this.snapTimer = setTimeout(() => {
              if (toLeft) { x -= setWidth; index = 0; }
              else { x += setWidth; index = count; }
              apply(false);
            }, duration + 30);
          }
        }, Math.max(delay, duration + 100));
      }

      stopSlide() {
        clearInterval(this.slideTimer);
        clearTimeout(this.snapTimer);
      }
    }

    customElements.define('logo-marquee', LogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('rf-hero')) return;
  var TICK = 150;
  class RfHero extends HTMLElement {
    constructor() {
      super();
      this.i = 0;
      this.p = 0;
      this.n = 0;
      this.hover = false;
      this.held = false;
      this.kbd = false;
      var self = this;
      this.addEventListener('mouseenter', function () { if (self.dataset.pauseHover === 'true') self.hover = true; });
      this.addEventListener('mouseleave', function () { self.hover = false; });
      this.addEventListener('focusin', function (e) {
        var t = e.target;
        try { if (t && t.matches && t.matches(':focus-visible')) self.kbd = true; } catch (err) {}
      });
      this.addEventListener('focusout', function (e) { if (!e.relatedTarget || !self.contains(e.relatedTarget)) self.kbd = false; });
      this.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-rf-go]') : null;
        if (!t || !self.contains(t)) return;
        var v = t.getAttribute('data-rf-go');
        if (v === 'prev') self.go(self.i - 1);
        else if (v === 'next') self.go(self.i + 1);
        else self.go(parseInt(v, 10) || 0);
      });
      this.addEventListener('shopify:block:select', function (e) {
        var el = e.target && e.target.closest ? e.target.closest('.rf-slide') : null;
        var k = self.slides ? self.slides.indexOf(el) : -1;
        if (k > -1) { self.held = true; self.go(k); }
      });
      this.addEventListener('shopify:block:deselect', function () { self.held = false; });
    }
    connectedCallback() {
      var self = this;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { self.init(); }, { once: true });
      else this.init();
    }
    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
    init() {
      if (!this.isConnected) return;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.rf-slide'));
      this.segs = Array.prototype.slice.call(this.querySelectorAll('.rf-seg'));
      this.n = this.slides.length;
      if (!this.n) return;
      var on = -1;
      for (var k = 0; k < this.n; k++) if (this.slides[k].classList.contains('is-on')) { on = k; break; }
      this.i = on > -1 ? on : 0;
      this.p = 0;
      this.seconds = Math.max(1, parseFloat(this.dataset.seconds) || 7);
      this.rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      this.render();
      if (this.timer) clearInterval(this.timer);
      var self = this;
      this.timer = setInterval(function () { self.tick(); }, TICK);
    }
    auto() {
      return this.n > 1 && this.dataset.autoplay === 'true' && this.dataset.motion !== 'off' && !(this.rm && this.rm.matches);
    }
    tick() {
      if (!this.auto() || this.hover || this.held || this.kbd) return;
      var p = this.p + TICK / (this.seconds * 1000);
      if (p >= 1) { this.i = (this.i + 1) % this.n; this.p = 0; }
      else this.p = p;
      this.render();
    }
    go(k) {
      if (!this.n) return;
      this.i = ((k % this.n) + this.n) % this.n;
      this.p = 0;
      this.render();
    }
    render() {
      var i = this.i, auto = this.auto(), p = this.p;
      this.slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      this.segs.forEach(function (g, k) {
        var cur = k === i;
        g.setAttribute('aria-current', cur ? 'true' : 'false');
        var label = g.querySelector('.rf-seg-label');
        if (label) label.style.color = cur ? '#ffffff' : 'rgba(255,255,255,0.45)';
        var fill = g.querySelector('.rf-seg-fill');
        if (fill) fill.style.width = (cur ? (auto ? Math.round(p * 1000) / 10 : 100) : (k < i ? 100 : 0)) + '%';
      });
    }
  }
  customElements.define('rf-hero', RfHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-product-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('rf-explorer')) return;

    var BR = function (a) { return a === 0 ? 1 : (a === 1 ? 0.55 : 0.35); };
    var TF = function (a, sg) {
      if (a === 0) return 'translate3d(0, 0, 0) rotateY(0deg) scale(1)';
      if (a === 1) return 'translate3d(' + (sg * 58) + '%, 0, -220px) rotateY(' + (-sg * 32) + 'deg) scale(0.86)';
      if (a === 2) return 'translate3d(' + (sg * 98) + '%, 0, -420px) rotateY(' + (-sg * 40) + 'deg) scale(0.74)';
      return 'translate3d(0, 0, -640px) scale(0.6)';
    };

    class RfExplorer extends HTMLElement {
      connectedCallback() {
        this.deck = this.querySelector('[data-rf-deck]');
        this.cards = Array.prototype.slice.call(this.querySelectorAll('.rf-card'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('.rf-thumb'));
        this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-rf-panel]'));
        this.n = this.cards.length;
        if (!this.deck || !this.n) return;
        // start from what the markup shows (server renders the first card; a moved element keeps its card)
        this.sel = Math.max(0, this.panels.findIndex((p) => !p.hidden));
        this.dragX = null;
        this.swiped = false;

        this.onDown = (e) => { this.dragX = e && typeof e.clientX === 'number' ? e.clientX : null; this.swiped = false; };
        this.onUp = (e) => {
          if (this.dragX == null || !e || typeof e.clientX !== 'number') return;
          var dx = e.clientX - this.dragX;
          this.dragX = null;
          if (Math.abs(dx) < 36) return;
          this.swiped = true;
          this.select(this.sel + (dx < 0 ? 1 : -1));
        };
        this.onCancel = () => { this.dragX = null; };
        this.onCard = (e) => {
          if (this.swiped) { this.swiped = false; return; }
          var i = this.cards.indexOf(e.currentTarget);
          if (i > -1) this.select(i);
        };
        this.onThumb = (e) => {
          var i = this.thumbs.indexOf(e.currentTarget);
          if (i > -1) this.select(i);
        };
        this.onBlockSelect = (e) => {
          var d = e.detail || {};
          if (d.sectionId !== this.dataset.sectionId) return;
          var i = this.cards.findIndex((c) => c.dataset.blockId === d.blockId);
          if (i > -1) this.select(i);
        };

        this.deck.addEventListener('pointerdown', this.onDown);
        this.deck.addEventListener('pointerup', this.onUp);
        this.deck.addEventListener('pointercancel', this.onCancel);
        this.cards.forEach((c) => c.addEventListener('click', this.onCard));
        this.thumbs.forEach((t) => t.addEventListener('click', this.onThumb));
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        // Theme editor: a setting change re-renders the section; keep the card that was selected (no transition).
        var kept = RfExplorer.kept[this.dataset.sectionId];
        if (window.Shopify && window.Shopify.designMode && kept && kept < this.n) {
          this.sel = kept;
          this.cards.forEach((c) => { c.style.transition = 'none'; });
          this.render();
          void this.deck.offsetWidth;
          this.cards.forEach((c) => { c.style.transition = ''; });
        }
      }

      disconnectedCallback() {
        if (!this.deck) return;
        this.deck.removeEventListener('pointerdown', this.onDown);
        this.deck.removeEventListener('pointerup', this.onUp);
        this.deck.removeEventListener('pointercancel', this.onCancel);
        this.cards.forEach((c) => c.removeEventListener('click', this.onCard));
        this.thumbs.forEach((t) => t.removeEventListener('click', this.onThumb));
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(i) {
        if (typeof i !== 'number' || isNaN(i)) return;
        var n = this.n;
        this.sel = ((i % n) + n) % n;
        RfExplorer.kept[this.dataset.sectionId] = this.sel;
        this.render();
      }

      render() {
        var N = this.n, sel = this.sel;
        this.cards.forEach((c, i) => {
          var d = ((i - sel) % N + N) % N;
          if (d > N / 2) d -= N;
          var a = Math.abs(d), sg = Math.sign(d), br = BR(a);
          c.style.transform = TF(a, sg);
          c.style.opacity = a === 0 || a === 1 ? 1 : (a === 2 ? 0.55 : 0);
          c.style.zIndex = 10 - a;
          c.style.pointerEvents = a <= 2 ? 'auto' : 'none';
          c.setAttribute('aria-hidden', a <= 2 ? 'false' : 'true');
          c.setAttribute('tabindex', a <= 2 ? '0' : '-1');
          c.setAttribute('aria-label', a === 0 ? c.dataset.name : c.dataset.side);
          var img = c.querySelector('.rf-card-img');
          if (img) img.style.filter = 'drop-shadow(0 44px 56px rgba(0,0,0,0.85)) brightness(' + br + ')';
          var badge = c.querySelector('.rf-cb');
          if (badge) badge.style.filter = 'brightness(' + br + ')';
        });
        this.thumbs.forEach((t, i) => {
          t.setAttribute('aria-pressed', i === sel ? 'true' : 'false');
          t.style.borderColor = i === sel ? '#ffffff' : 'rgba(255,255,255,0.1)';
        });
        this.panels.forEach((p, i) => { p.hidden = i !== sel; });
      }
    }
    RfExplorer.kept = {};
    customElements.define('rf-explorer', RfExplorer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Desktop arrows page the track one card at a time, like the canvas: translateX(-i * (card width + gap)).
     The last position shows the last cards that fit. Phone (and "arrows off"): the rail scrolls natively and the
     transform is ignored (rf-base.css sets transform:none on phones). */
  class RfRevcar extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.rf-rv-rail');
      this.track = this.querySelector('.rf-rv-track');
      if (!this.rail || !this.track) return;
      this.i = 0;
      this.prev = this.querySelector('[data-rf-prev]');
      this.next = this.querySelector('[data-rf-next]');
      this.onPrev = () => this.go(this.i - 1);
      this.onNext = () => this.go(this.i + 1);
      this.onFocus = (e) => this.reveal(e.target);
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('focusin', this.onFocus);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.go(this.i));
        this.ro.observe(this.rail);
      }
      this.go(0);
    }
    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('focusin', this.onFocus);
      if (this.ro) this.ro.disconnect();
      this.ro = null;
    }
    paged() {
      return getComputedStyle(this.rail).overflowX === 'hidden';
    }
    metrics() {
      const cards = this.track.children;
      if (!cards.length) return { step: 0, max: 0, visible: 1 };
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = cards[0].getBoundingClientRect().width + gap;
      const visible = step > 0 ? Math.max(1, Math.floor((this.rail.clientWidth + gap) / step)) : 1;
      return { step, max: Math.max(0, cards.length - visible), visible };
    }
    go(i) {
      const m = this.metrics();
      this.i = Math.max(0, Math.min(m.max, i));
      this.track.style.transform = this.i ? 'translateX(' + (-this.i * m.step) + 'px)' : '';
    }
    reveal(el) {
      if (!this.paged()) return;
      const card = el.closest('.rf-rv-card');
      if (!card) return;
      this.rail.scrollLeft = 0;
      requestAnimationFrame(() => { this.rail.scrollLeft = 0; });
      const idx = Array.prototype.indexOf.call(this.track.children, card);
      const m = this.metrics();
      if (idx < this.i) this.go(idx);
      else if (idx >= this.i + m.visible) this.go(idx - m.visible + 1);
    }
  }
  if (!customElements.get('rf-revcar')) customElements.define('rf-revcar', RfRevcar);
})();

  } catch(e) { console.error(e); }
})();
})();
